"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fopen = fopen;
exports.fopenString = fopenString;
exports.fclose = fclose;
exports.fcloseValue = fcloseValue;
exports.fread = fread;
exports.freadHandle = freadHandle;
exports.fwrite = fwrite;
exports.fseek = fseek;
exports.fseekHandle = fseekHandle;
exports.fseekln = fseekln;
exports.fseeklnHandle = fseeklnHandle;
exports.feof = feof;
exports.freadln = freadln;
exports.freadlnHandle = freadlnHandle;
exports.ftell = ftell;
exports.ftellHandle = ftellHandle;
exports.ftellln = ftellln;
exports.ftelllnHandle = ftelllnHandle;
const ediabasx_core_1 = require("@emdzej/ediabasx-core");
const register_values_1 = require("./register-values");
function fopen(fileSystem, registers, destination, pathRef, modeRef, flags) {
    const path = (0, register_values_1.getStringValue)(registers, pathRef);
    const mode = typeof modeRef === "string"
        ? modeRef
        : modeRef
            ? (0, register_values_1.getStringValue)(registers, modeRef)
            : "r";
    fopenString(fileSystem, registers, destination, path, flags, mode);
}
/** fopen variant taking a resolved filename string (for polymorphic operands). */
function fopenString(fileSystem, registers, destination, path, flags, mode = "r") {
    let handle = -1;
    try {
        handle = fileSystem.open(path, mode);
    }
    catch {
        handle = -1;
    }
    (0, register_values_1.setIntValue)(registers, destination, handle);
    if (flags) {
        const masked = handle & 0xff;
        flags.z = masked === 0;
        flags.s = (masked & 0x80) !== 0;
    }
}
function fclose(fileSystem, registers, handleRef) {
    const handle = (0, register_values_1.getIntValue)(registers, handleRef);
    fileSystem.close(handle);
}
/** fclose variant taking a resolved handle value. */
function fcloseValue(fileSystem, handle) {
    fileSystem.close(handle);
}
function fread(fileSystem, registers, destination, handleRef, flags) {
    const handle = (0, register_values_1.getIntValue)(registers, handleRef);
    freadHandle(fileSystem, registers, destination, handle, flags);
}
/** fread variant taking a resolved handle value. */
function freadHandle(fileSystem, registers, destination, handle, flags) {
    let value = -1;
    try {
        const data = fileSystem.read(handle, 1);
        if (data.length > 0) {
            value = data[0];
        }
    }
    catch {
        value = -1;
    }
    if (value < 0) {
        value = 0;
        if (flags) {
            flags.c = true;
        }
    }
    else if (flags) {
        flags.c = false;
    }
    (0, register_values_1.setIntValue)(registers, destination, value);
}
function fwrite(fileSystem, registers, handleRef, source) {
    const handle = (0, register_values_1.getIntValue)(registers, handleRef);
    const data = (0, ediabasx_core_1.utf8ToCp1252)((0, register_values_1.getStringValue)(registers, source));
    fileSystem.write(handle, data);
}
function fseek(fileSystem, registers, handleRef, offsetRef, origin = "start") {
    const handle = (0, register_values_1.getIntValue)(registers, handleRef);
    const offset = (0, register_values_1.getIntValue)(registers, offsetRef);
    fseekHandle(fileSystem, handle, offset, origin);
}
/** fseek variant taking resolved handle/offset values. */
function fseekHandle(fileSystem, handle, offset, origin = "start") {
    fileSystem.seek(handle, offset, origin);
}
function fseekln(fileSystem, registers, handleRef, offsetRef) {
    const handle = (0, register_values_1.getIntValue)(registers, handleRef);
    const line = (0, register_values_1.getIntValue)(registers, offsetRef);
    fseeklnHandle(fileSystem, handle, line);
}
/** fseekln variant taking resolved handle/line values. */
function fseeklnHandle(fileSystem, handle, line) {
    fileSystem.seek(handle, 0, "start");
    for (let i = 0; i < line; i++) {
        if (fileSystem.readLine) {
            const data = fileSystem.readLine(handle);
            if (!data) {
                break;
            }
        }
        else {
            let readAny = false;
            while (!fileSystem.eof(handle)) {
                const byte = fileSystem.read(handle, 1);
                if (byte.length === 0) {
                    break;
                }
                readAny = true;
                if (byte[0] === 0x0a) {
                    break;
                }
            }
            if (!readAny) {
                break;
            }
        }
    }
}
function feof(fileSystem, registers, destination, handleRef) {
    const handle = (0, register_values_1.getIntValue)(registers, handleRef);
    (0, register_values_1.setIntValue)(registers, destination, fileSystem.eof(handle) ? 1 : 0);
}
/**
 * FREADLN - Read a line from file.
 * Reads until newline (LF) or EOF. CR is stripped.
 */
function freadln(fileSystem, registers, destination, handleRef, flags) {
    const handle = (0, register_values_1.getIntValue)(registers, handleRef);
    freadlnHandle(fileSystem, registers, destination, handle, flags);
}
/** freadln variant taking a resolved handle. */
function freadlnHandle(fileSystem, registers, destination, handle, flags) {
    let data = null;
    if (fileSystem.readLine) {
        data = fileSystem.readLine(handle);
    }
    else {
        // Fallback: read byte by byte until newline
        const bytes = [];
        let readAny = false;
        while (!fileSystem.eof(handle)) {
            const byte = fileSystem.read(handle, 1);
            if (byte.length === 0)
                break;
            readAny = true;
            if (byte[0] === 0x0a)
                break;
            if (byte[0] !== 0x0d) {
                bytes.push(byte[0]);
            }
        }
        data = readAny ? new Uint8Array(bytes) : null;
    }
    // Mirrors C# `OpFreadln` (EdOperations.cs:1091): writes the line
    // bytes via `SetArrayData(byte[])` — no NUL terminator. The string
    // path (`SetStringData`) would grow the buffer by one whenever the
    // last line byte isn't already `0x00`, throwing off any caller that
    // length-checks the result.
    if (!data) {
        (0, register_values_1.setBinaryValue)(registers, destination, new Uint8Array());
        if (flags) {
            flags.c = true;
        }
        return;
    }
    (0, register_values_1.setBinaryValue)(registers, destination, data);
    if (flags) {
        flags.c = false;
    }
}
/**
 * FTELL - Get current file position (byte offset).
 */
function ftell(fileSystem, registers, destination, handleRef) {
    const handle = (0, register_values_1.getIntValue)(registers, handleRef);
    ftellHandle(fileSystem, registers, destination, handle);
}
/** ftell variant taking a resolved handle. */
function ftellHandle(fileSystem, registers, destination, handle) {
    const position = fileSystem.tell ? fileSystem.tell(handle) : 0;
    (0, register_values_1.setIntValue)(registers, destination, position);
}
/**
 * FTELLLN - Get current line number in file.
 */
function ftellln(fileSystem, registers, destination, handleRef) {
    const handle = (0, register_values_1.getIntValue)(registers, handleRef);
    ftelllnHandle(fileSystem, registers, destination, handle);
}
/** ftellln variant taking a resolved handle. */
function ftelllnHandle(fileSystem, registers, destination, handle) {
    const lineNumber = fileSystem.tellLine ? fileSystem.tellLine(handle) : 0;
    (0, register_values_1.setIntValue)(registers, destination, lineNumber);
}
//# sourceMappingURL=file.js.map